import React, { FC } from 'react'

import { map } from 'lodash'

import { Text } from '@interco/inter-ui/components/Text'

import { Report } from '../../../types/YourPersonalData.types'
import { ReportsMonthSection } from '../reports-month-section/ReportsMonthSection'

type ReportsYearSectionProps = {
  year: string
  reporstByYear: Record<string, Report[]>
}

export const ReportsYearSection: FC<ReportsYearSectionProps> = ({ year, reporstByYear }) => (
  <>
    <Text variant="headline-h2" color="typography" colorWeight={500} semiBold>
      {year}
    </Text>
    {map(reporstByYear, (reportsByMonth, monthName) => (
      <ReportsMonthSection key={monthName} monthName={monthName} reportByMonth={reportsByMonth} />
    ))}
  </>
)
